import {observable, action, runInAction, computed, autorun, toJS} from "mobx";
import appstate, { IAppMode } from "../appstate";

class RoomStore {

    @observable cache: CC.Library.Models.Availability.AvailabilityResponse[]
    @observable isLoading: boolean;
    
    private xhrRefs: XMLHttpRequest[];
    private prefRoomTypeCode: string[];

    constructor () {
        this.cache = [];
        //for (let i=0; NCB.Settings.HotelProperties.MaxReservationsPerItinerary > i; i++) {
        //    this.cache.push(null);
        //}

        this.isLoading = true;
        this.xhrRefs = [];
        
        // Get preferred room from the URL
        this.prefRoomTypeCode = [];
        location.search.substr(1).split("&").forEach((item) => {
            let s = item.split("=");
            switch (s[0]) {
                case "roomTypeCode":
                    if (s[1] != null && s[1].length > 0)
                        this.prefRoomTypeCode.push(s[1]);
                    break;
            }
        });

    }
    @action
    loadRooms = (roomIndex: number, 
                 startDate: Date, 
                 endDate: Date, 
                 guests: CC.Library.Models.Shared.NcbGuestCount[], 
                 promotionCode: string, 
                 ratePlanOrGroupCode: string) => {

        if (startDate == null)
            return;
        
        if (endDate == null)
            return;

        if (this.xhrRefs[roomIndex] != null)
            this.xhrRefs[roomIndex].abort();

        // Clear the cache for this index to indicate that the current room is loading
        this.cache[roomIndex] = null;
        this.isLoading = true;

        let handler: NCB.Availability.IAvailabilityResponse = {
            success: (res: CC.Library.Models.Availability.AvailabilityResponse) => {

                if (res.Rooms.length === 0) {
                    runInAction(() => {
                        this.cache[roomIndex] = res;
                        this.isLoading = this.cache.filter(x => x != null).length !== appstate.reservations.length;
                    });
                } else {
                    let o: NCB.Availability.IFilterAvailability = {
                        isNonRoom: appstate.isNonRoom
                    };

                    if (appstate.modifyConfirmationNumber != null && appstate.modifyConfirmationNumber.length > 0) {
                        o.guaranteeCode = NCB.Session.getSession().reservations[0].Reservations[0].Rooms[0].Guarantee.Code; 
                    }
    
                    res = NCB.Availability.filterAvailability(res, roomIndex, o);
            
                    runInAction(() => {
                        this.cache[roomIndex] = res;
                        this.isLoading = this.cache.filter(x => x != null).length !== appstate.reservations.length;
                        this.findRooms();
                    });
                }

                console.log("roomStore CACHE", this.isLoading, toJS(this.cache));
            },
            error: (error: NCB.Proxy.ICompoundError) => {
                NCB.Log.customError("Error loading rooms ", error);
            }
        }
        
        this.xhrRefs[roomIndex] = NCB.Availability.loadRooms(handler, startDate, endDate, guests, promotionCode, ratePlanOrGroupCode, (appstate != null) ? appstate.modifyConfirmationNumber : "");
    }

    filterCacheByGuaranteeCodes = () => {
        console.log("roomStore.filterCacheByGuaranteeCodes(): Start");
        // Filter out the guarantee codes that does not exist across all rooms
        let allGuaranteeCodes: string[] = null;
        this.cache.forEach(c => {
            let currentGuaranteeCodes = c.Rooms.map(x => x.RatePlan.Guarantee.Code).filter(NCB.Utils.unique);
            if (allGuaranteeCodes == null) {
                allGuaranteeCodes = currentGuaranteeCodes;
                console.log("roomStore.filterCacheByGuaranteeCodes(): allGuaranteeCodes", allGuaranteeCodes);
            } else {
                // Remove all guarantee codes that is not present in the current room
                console.log("roomStore.filterCacheByGuaranteeCodes(): allGuaranteeCodes", allGuaranteeCodes, currentGuaranteeCodes);
                allGuaranteeCodes = allGuaranteeCodes.filter(gc => currentGuaranteeCodes.indexOf(gc) !== -1);
            }
        });

        this.cache.forEach(c => {
            c.Rooms = c.Rooms.filter(x => allGuaranteeCodes.indexOf(x.RatePlan.Guarantee.Code) > -1);
        });

        console.log("roomStore.filterCacheByGuaranteeCodes(): remaining", allGuaranteeCodes);
    }

    findRooms = () => {
        // Are we still waiting for a result?
        if (this.cache.filter(x => x != null).length !== appstate.reservations.length) {
            console.log("roomStore.findRooms(): Waiting for cache...", this.cache.filter(x => x != null).length, appstate.reservations.length);
            return;
        }

        console.log("roomStore.findRooms(): Proceeding");

        let firstRoom = appstate.reservations[0].Rooms[0];

        // Only booking one room?
        if (appstate.reservations.length === 1) {
            if (!appstate.guestHasChangedRoom) {
                this.findRoomInCache(0);
                return; 
            }
            
            // Verify that the selected room is still available
            let res = this.cache[0];
            let rc = res.Rooms.filter(x => x.RatePlan.Code === firstRoom.RatePlan && x.RoomType.Code === firstRoom.RoomType);
    
            if (rc.length === 0) 
                this.findRoomInCache(0); // The room is no longer available

            return;
        }

        this.filterCacheByGuaranteeCodes();

        appstate.reservations.forEach((r, i) => {
            if (appstate.reservations[i].Rooms[0].RoomType == null) {
                this.findRoomInCache(i);
            } 

            // Is the currently selected room still available?
            let res = this.cache[i];
            let rc = res.Rooms.filter(x => x.RatePlan.Code === appstate.reservations[i].Rooms[0].RatePlan && x.RoomType.Code === appstate.reservations[i].Rooms[0].RoomType);
     
            if (rc.length === 0) 
                this.findRoomInCache(i);

        });
    }

    // Make sure that the automatically selected Rate is shown first in the package list
    setFirstRoomPrio = (rateCode: string) => {
        let feature = NCB.Settings.FeatureMatrixConfiguration.Rates.filter(x => x.Codes.indexOf(rateCode) > -1)[0];
        let linkedLoyaltyFeature = NCB.Settings.FeatureMatrixConfiguration.Rates.filter(x => x.ChoiceClubRate == rateCode)[0];
        if (feature != null) {
            NCB.Settings.FeatureMatrixConfiguration.Rates.forEach(x => x.Prio++);
            feature.Prio = 0;
            if (linkedLoyaltyFeature != null)
                linkedLoyaltyFeature.Prio = 0;

            NCB.Settings.FeatureMatrixConfiguration.Rates = NCB.Settings.FeatureMatrixConfiguration.Rates.sort((a,b) => a.Prio - b.Prio);
        }
    }

    findRoomInCache = (roomIndex: number) => {
        // Get the initial room
        let guaranteeCode: string = null;
        if (roomIndex > 0)
            guaranteeCode = appstate.getGuaranteeCode(0);
            
        let params: NCB.Availability.IInitialRoomParams = {
            roomTypeCode: (!appstate.guestHasChangedRoom && this.prefRoomTypeCode.length > 0) ? this.prefRoomTypeCode : null,
            guaranteeCode: guaranteeCode
        }
        
        let roomCache = appstate.reservations.length > 1 ? this.reducedRoomAvailability(roomIndex) : this.cache[roomIndex];

        let initialRoom = NCB.Availability.findInitialRoom(roomCache, roomIndex, params, appstate.reservations[0].Rooms[0].RatePlan, appstate.reservations[0].Rooms[0].RoomType);

        if (initialRoom != null) {
            this.setFirstRoomPrio(initialRoom.rateCode);
            appstate.setRoom(roomIndex, initialRoom.roomTypeCode, initialRoom.rateCode);
        } else {
            NCB.Log.customError("roomPage.loadRoomsCallback(): could not find initial room", {guaranteeCode: guaranteeCode});
        }
    }

    lastMetricSent: string = "";
    sendMetrics = (signature: string): boolean => {

        if (appstate.doShowCalendarPage || appstate.appMode != IAppMode.Wizard || signature === this.lastMetricSent || appstate.reservations == null || appstate.reservations[appstate.roomIndex] == null || this.cache == null || this.cache[appstate.roomIndex] == null) {
            return false;
        }
        
        let r = appstate.reservations[appstate.roomIndex];
        let room = r.Rooms[0];

        let candidate = this.cache[appstate.roomIndex].Rooms.filter(x => x.RoomType.Code === room.RoomType && x.RatePlan.Code === room.RatePlan)[0];
        
        if (candidate != null && this.lastMetricSent.length > 0) {
            NCB.Metrics.handleProductDetail(appstate.roomIndex, (room.RoomType + " - " + room.RatePlan), room.RoomType, room.RoomType, room.RatePlan, room.RatePlan, candidate.Price.AmountAfterTax, 1);
            
            this.lastMetricSent = signature;

            return true;
        } else {
            this.lastMetricSent = signature;

            return false;
        }
        
    }

    // Filter the availability for a specific room index in the case that not all room types are available for all rooms in one reservation
    reducedRoomAvailability = (roomIndex: number): CC.Library.Models.Availability.AvailabilityResponse => {
        let out: CC.Library.Models.Availability.AvailabilityResponse = {
            EndDate: this.cache[roomIndex].EndDate,
            StartDate: this.cache[roomIndex].StartDate,
            Success: this.cache[roomIndex].Success,
            Rooms: []
        };

        this.cache[roomIndex].Rooms.forEach(x => {
            if (parseInt(x.RoomType.NumberOfUnits) > appstate.reservations.length) {
                // No need to filter since we have more available rooms than we need
                //console.log("*** reducedRoomAvailability No need to filter", x.RatePlan.Code, x.RoomType.Code);
            } else {
                let remainingRooms = parseInt(x.RoomType.NumberOfUnits);
                for (let i=0; appstate.reservations.length > i; i++) {
                    if (i !== roomIndex) {
                        let currentRoom = appstate.reservations[i].Rooms[0];
                        if (x.RatePlan.Code === currentRoom.RatePlan && x.RoomType.Code === currentRoom.RoomType) {
                            remainingRooms--;
                        }
                    }
                }

                if (remainingRooms < 1) {
                    //console.log("*** reducedRoomAvailability Exhausted room/rate (available)", x.RoomType.Code, x.RatePlan.Code, x.RoomType.NumberOfUnits);
                    return;
                } else {
                    //console.log("*** reducedRoomAvailability Checked room/rate (available)", x.RoomType.Code, x.RatePlan.Code, x.RoomType.NumberOfUnits);
                }
            }

            out.Rooms.push(x);
       });

       return out;
    }
}

const roomstore = new RoomStore();

export default roomstore;


// WEBPACK FOOTER //
// ./src/stores/roomStore.ts